var _path, _mask, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNzd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#00207F"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "#00207F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L0 17M10 10L20 3L10 10Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L20 17M10 10L0 3L10 10Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L20 17M10 10L0 3L10 10Z",
    stroke: "#D10D24",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L0 17M10 10L20 3L10 10Z",
    stroke: "#D10D24",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.5H20.5V11.5H11.5V20.5H8.5V11.5H-0.5V8.5H8.5V-0.5H11.5V8.5Z",
    fill: "#D10D24",
    stroke: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 9.15439L28.7639 9.80423L29 8.42784L28 7.45308L29.382 7.25227L30 6L30.618 7.25227L32 7.45308L31 8.42784L31.2361 9.80423L30 9.15439Z",
    fill: "#D10D24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 18.1544L33.7639 18.8042L34 17.4278L33 16.4531L34.382 16.2523L35 15L35.618 16.2523L37 16.4531L36 17.4278L36.2361 18.8042L35 18.1544Z",
    fill: "#D10D24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 19.1544L23.7639 19.8042L24 18.4278L23 17.4531L24.382 17.2523L25 16L25.618 17.2523L27 17.4531L26 18.4278L26.2361 19.8042L25 19.1544Z",
    fill: "#D10D24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 33.1544L28.7639 33.8042L29 32.4278L28 31.4531L29.382 31.2523L30 30L30.618 31.2523L32 31.4531L31 32.4278L31.2361 33.8042L30 33.1544Z",
    fill: "#D10D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzd);
export default __webpack_public_path__ + "static/media/nzd.8351f678b9a6f96760081e664a5ee6a4.svg";
export { ForwardRef as ReactComponent };